@if (!isMobileView) {
  <div class="container">
    <mat-toolbar class="row navBar nav-container">
      <span class="bold-600 medium-font">{{
        productService.currentProductData().name
      }}</span>
      <span class="medium-font">{{
        productService.currentProductData().brand
      }}</span>
    </mat-toolbar>

    <div class="grid-container">
      <app-product-side-menu></app-product-side-menu>
      <div><router-outlet></router-outlet></div>
    </div>
  </div>
}

@if (isMobileView) {
  <div><router-outlet></router-outlet></div>
}
